import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { throttle } from "lodash";
import Swipe from "react-easy-swipe";
import VideoGalleryItem from "~/scripts/components/VideoGalleryItem";

const FORMAT = {
    medium: "medium",
    large: "large",
    xLarge: "x-large",
    xxLarge: "xx-large"
};

class VideoGallery extends Component {
    static propTypes = {
        films: PropTypes.array,
        initialFilmId: PropTypes.string,
        toggleSpecialPageTransition: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            currentIndex: 0,
            switching: false,
            format: FORMAT.xLarge
        };

        this.handleResize = throttle(this.handleResize.bind(this), 250);
    }

    componentDidMount() {
        this.setCurrentIndexFromFilmId();

        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    }

    componentDidUpdate(prevProps) {
        const { films } = this.props;

        if (prevProps.films !== films) {
            this.setCurrentIndexFromFilmId();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    onSwipeRight = () => {
        const { currentIndex } = this.state;
        const newIndex = currentIndex - 1;

        if (newIndex < 0) return;

        this.setState({ currentIndex: newIndex, switching: true });

        setTimeout(() => {
            this.setState({ switching: false });
        }, 600);
    };

    onSwipeLeft = () => {
        const { currentIndex } = this.state;
        const { films } = this.props;
        const newIndex = currentIndex + 1;

        if (newIndex > films.length - 1) return;

        this.setState({ currentIndex: newIndex, switching: true });

        setTimeout(() => {
            this.setState({ switching: false });
        }, 600);
    };

    setCurrentIndexFromFilmId = () => {
        const { initialFilmId, films } = this.props;

        if (initialFilmId && films && films.length > 0) {
            const index = films.findIndex(film => film.id === initialFilmId);
            this.setState({ currentIndex: index });
        }
    };

    handleClick = externalLink => (e, index) => {
        const { toggleSpecialPageTransition } = this.props;
        const { currentIndex } = this.state;

        // IF clicked NOT a current video
        if (currentIndex !== index) {
            e.preventDefault();
            // Otherwise select clicked video
            this.setState({ currentIndex: index, switching: true });

            setTimeout(() => {
                this.setState({ switching: false });
            }, 600);
        } else {
            // If we clicked the current slide
            if (e.target && e.target.classList.contains("is-video")) {
                toggleSpecialPageTransition(true, null, true);
            }
        }
    };

    handleResize() {
        let format = FORMAT.xxLarge;

        if (window.matchMedia("(max-width: 1680px)").matches) {
            format = FORMAT.xLarge;
        }

        if (window.matchMedia("(max-width: 1170px)").matches) {
            format = FORMAT.large;
        }

        if (window.matchMedia("(max-width: 900px)").matches) {
            format = FORMAT.medium;
        }

        this.setState({ format });
    }

    getTransform = () => {
        const { format } = this.state;

        switch (format) {
            case FORMAT.xxLarge:
                return this.getTransformValue(2.5, 8, 1);
            case FORMAT.xLarge:
                return this.getTransformValue(2.25, 9, 0.75);
            case FORMAT.large:
                return this.getTransformValue(2, 10, 0.5);
            case FORMAT.medium:
                return this.getTransformValue(2, 10, 0.5);
        }
    };

    getTransformValue = (offsetColumns, itemColumns, marginColumns) => {
        const { currentIndex } = this.state;
        const colWidth = 100 / 15;

        return `translateX(${colWidth * offsetColumns -
            colWidth * (itemColumns + 2 * marginColumns) * currentIndex}vw)`;
    };

    render() {
        const { films, directorSlug, entryType } = this.props;
        const { currentIndex, switching } = this.state;

        if (!films || films.length === 0) {
            return null;
        }

        const transform = this.getTransform();

        return (
            <div className="video-gallery">
                <Swipe
                    onSwipeLeft={this.onSwipeLeft}
                    onSwipeRight={this.onSwipeRight}
                >
                    <div
                        className={classNames("video-gallery__container", {
                            switching
                        })}
                        style={{ transform }}
                    >
                        {films.map((film, index) => {
                            return (
                                <VideoGalleryItem
                                    key={index}
                                    film={film}
                                    entryType={entryType}
                                    directorSlug={directorSlug}
                                    index={index}
                                    isCurrent={currentIndex === index}
                                    onClick={this.handleClick(
                                        film.externalLink
                                            ? film.externalLink
                                            : ""
                                    )}
                                />
                            );
                        })}
                    </div>
                </Swipe>
            </div>
        );
    }
}

export default VideoGallery;



// WEBPACK FOOTER //
// ./src/scripts/components/VideoGallery.js